import {
	IMAGES_URL,
	ISubNavigationItem,
	PROJECT_NAME,
	PROJECTS_NAVIGATION_ITEMS,
} from "data/constants";
import emptyPlayer from "assets/img/empty_player.png";
import {filter, find, isNull} from "lodash";
import type {ISession} from "data/stores/rounds/rounds.store";

export const getOpenState = (value: boolean) => (value ? "open" : "closed");

export const getPlayerHeadshot = (playerId: number) => {
	return playerId ? `${IMAGES_URL}players/${playerId}.png` : emptyPlayer;
};

export const getPlayerFlag = (country: string) => {
	return `${IMAGES_URL}flags/${country}.png`;
};

export const getProjectNavigation = () => {
	const activeProject = find(
		PROJECTS_NAVIGATION_ITEMS,
		({projectName}) => projectName === PROJECT_NAME
	);
	const filteredProjects = filter(
		PROJECTS_NAVIGATION_ITEMS.filter((it) => !it.hidden),
		({projectName}) => projectName !== PROJECT_NAME
	);

	return {
		name: activeProject?.name,
		to: "/",
		subItems: filteredProjects,
	} as ISubNavigationItem;
};

export const numberOrDashes = (value: number | null) => (!isNull(value) ? value : "--");

export const getCapBtnClass = (value: boolean, isButton: boolean) => {
	if (isButton) {
		return value ? "selected" : "";
	}
	return value ? "selected d_view" : "d_view";
};

export const getMobileCapBtnClass = (value: boolean) => {
	return value ? "selected m_view" : "m_view";
};

export async function cacheImages(images: string[]) {
	const promises = images.map((src) => {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.src = src;
			image.onload = resolve;
			image.onerror = reject;
		});
	});

	await Promise.all(promises);
}

export const getPlayerPoint = (points: number, isCapitan: boolean) => {
	return isCapitan ? points * 1.5 : points;
};

export const getCurrentSession = (
	viewOnly: boolean | undefined,
	userTeamSelectedSession: ISession | undefined,
	selectedSession: ISession | undefined
) => {
	return viewOnly ? userTeamSelectedSession : selectedSession;
};

export const getCurrentSessionId = (
	viewOnly: boolean | undefined,
	userTeamsSelectedSessionId: number,
	selectedSessionId: number
) => {
	return viewOnly ? userTeamsSelectedSessionId : selectedSessionId;
};
